import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Box
} from '@mui/material';

interface Props {
  models: string[];
  selectedModel?: string;
  onChange: (model: string | undefined) => void;
  loading?: boolean;
}

const commonSelectStyles = {
  '& .MuiSelect-select': {
    paddingTop: '12px',
    paddingBottom: '12px',
    minHeight: '25px !important',
  },
  '& .MuiSelect-outlined': {
    backgroundColor: '#1B2B3A',
    borderRadius: '8px',
    color: 'white',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '8px'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.3)'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00A4E0'
  },
  '& .MuiSelect-icon': {
    color: 'rgba(255, 255, 255, 0.7)'
  }
};

export const ModelSelector: React.FC<Props> = ({ 
  models, 
  selectedModel, 
  onChange,
  loading = false 
}) => {
  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        minWidth: '200px',
        height: '48px'  // Match the height of the Select component
      }}>
        <CircularProgress size={24} sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
      </Box>
    );
  }

  if (!models.length) {
    return null;
  }

  const handleChange = (e: any) => {
    const value = e.target.value || undefined;
    onChange(value);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <Select
        value={selectedModel || ''}
        onChange={handleChange}
        displayEmpty
        renderValue={(value) => {
          if (!value) return 'Default';
          return value;
        }}
        sx={{
          ...commonSelectStyles,
          '& .MuiSelect-select': {
            ...commonSelectStyles['& .MuiSelect-select'],
            '&.Mui-focused': {
              color: '#00A4E0'
            }
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: '#1B2B3A',
              maxHeight: 300,
              '& .MuiMenuItem-root': {
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)'
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(0, 164, 224, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 164, 224, 0.25)'
                  }
                }
              }
            }
          }
        }}
      >
        <MenuItem value="">
          <em>Default</em>
        </MenuItem>
        {models.map((model) => (
          <MenuItem key={model} value={model}>
            {model}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}; 